import useSWR from 'swr'

import { FetchError } from '../../../../../data/fetchError'
import { FetchResponse } from '../../../../../data/fetchResponse'
import { FetchResult } from '../../../../../data/fetchResult'
import { fetchJson } from '../../../../../data/fetchers'
import { CompanyCode, CompanyCodeCustomField } from '../../suppliers'

export function useAllCompanyCodes(
  includeCustomFields: boolean = false,
): FetchResult<CompanyCode[]> {
  // Build query parameters
  const params = new URLSearchParams()
  if (includeCustomFields) {
    params.append('includeCustomFields', includeCustomFields.toString())
  }
  const queryString = params.toString()
  const url = `/masterdata/companycodes${queryString ? `?${queryString}` : ''}`

  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<CompanyCode[]>,
    FetchError
  >(url, fetchJson<CompanyCode[]>)

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}

export function useCompanyCodeById(
  id?: string | null,
  includeCustomFields: boolean = false,
): FetchResult<CompanyCode> {
  // Build query parameters
  const params = new URLSearchParams()
  if (includeCustomFields) {
    params.append('includeCustomFields', includeCustomFields.toString())
  }

  const queryString = params.toString()

  let url = id ? `/masterdata/companycodes/${id}` : null
  url = url && queryString ? `${url}?${queryString}` : url

  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<CompanyCode>,
    FetchError
  >(url, fetchJson<CompanyCode>)

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}

export function useAllCompanyCodesCustomFields(
  companyCodeId: string,
): FetchResult<CompanyCodeCustomField[]> {
  const url = companyCodeId
    ? `/masterdata/companycodes/${companyCodeId}/customfields`
    : null

  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<CompanyCodeCustomField[]>,
    FetchError
  >(url, fetchJson<CompanyCodeCustomField[]>)

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}

export function useCompanyCodesCustomFieldById(
  companyCodeId?: string,
  customFieldId?: string,
): FetchResult<CompanyCodeCustomField> {
  const url =
    companyCodeId && customFieldId
      ? `/masterdata/companycodes/${companyCodeId}/customfields/${customFieldId}`
      : null
  const { data, error, isLoading, mutate } = useSWR<
    FetchResponse<CompanyCodeCustomField>,
    FetchError
  >(url, fetchJson<CompanyCodeCustomField>)

  return {
    data: data?.body,
    isLoading,
    error,
    mutate,
  }
}
